import React from "react";
import { Formik, useField } from "formik";
import ReCAPTCHA from "react-google-recaptcha";
import * as Yup from "yup";

const InputText = ({ label, ...props }) => {
  const [field, meta] = useField(props);
  return (
    <div className="np__field">
      <label className="np__label" htmlFor={props.id || props.name}>
        {label}
      </label>
      <input
        data-error={meta.touched && meta.error && true}
        className="np__input"
        {...field}
        {...props}
      />
      {meta.touched && meta.error ? (
        <div className="np__error">{meta.error}</div>
      ) : null}
    </div>
  );
};

const InputCB = ({ children, ...props }) => {
  const [field, meta] = useField({ ...props, type: "checkbox" });
  return (
    <div className="np__field">
      <label className="np__label--cb">
        <input type="checkbox" {...field} {...props} />
        <span>{children}</span>
      </label>
      {meta.touched && meta.error ? (
        <div className="np__error" data-block={true}>
          {meta.error}
        </div>
      ) : null}
    </div>
  );
};

const DownloadForm = (props) => {
  return (
    <section className="toc" aria-hidden={props.isVisible}>
      <div className="toc-wrapper no-purchase__wrapper">
        <button className="toc-close" onClick={() => props.toggleDownload()}>
          close modal
        </button>
        <div className="toc-content no-purchase__content">
          <Formik
            initialValues={{
              first_name: "",
              last_name: "",
              email: "",
              us_resident: false,
              recaptcha: "",
              selectedArtistId: props.selectedArtist.id,
              selectedArtistLink: props.selectedArtist.link,
            }}
            validationSchema={Yup.object({
              first_name: Yup.string().required("Required"),
              last_name: Yup.string().required("Required"),
              email: Yup.string()
                .email("Invalid email address")
                .required("Required"),
              us_resident: Yup.boolean()
                .required("Required")
                .oneOf(
                  [true],
                  "You must be an United States resident to participate."
                ),
              recaptcha: Yup.string().required(),
            })}
            onSubmit={(values) => {
              setTimeout(() => {
                const data = new FormData();
                data.append("first_name", values.first_name);
                data.append("last_name", values.last_name);
                data.append("email", values.email);
                data.append("us_resident", values.us_resident);
                data.append("g-recaptcha-response", values.recaptcha);
                data.append("selected_artist_id", values.selectedArtistId);
                data.append("selected_artist_link", values.selectedArtistLink);

                const requestOptions = {
                  method: "POST",
                  body: data,
                  credentials: "same-origin",
                };
                fetch(
                  "https://apigw.sweet.io/publicapi/registration/sweepstakes",
                  requestOptions
                )
                  .then((response) => {
                    if (response.ok == true) {
                      props.onFormSuccess(values.email);
                    } else {
                      console.error(
                        "Form submission error, response: ",
                        response
                      );
                    }
                  })
                  .then((_) => {})
                  .catch((error) => {
                    console.error("Form submission error: ", error);
                  });
              }, 400);
            }}>
            {({
              handleSubmit,
              setFieldValue,
              errors,
              isSubmitting,
              isValidating,
            }) => (
              <form className="np__form" onSubmit={handleSubmit}>
                <div className="no-purchase__title">No mobile phone?</div>
                <div className="no-purchase__title--sm">
                  Please complete the form to receive instructions on how to
                  receive your <strong>{props.selectedArtist.alias}</strong>{" "}
                  game piece.
                </div>
                <InputText
                  label="First Name"
                  name="first_name"
                  type="text"
                  placeholder="First name *"
                />
                <InputText
                  label="Last Name"
                  name="last_name"
                  type="text"
                  placeholder="Last name *"
                />
                <InputText
                  label="Email Address"
                  name="email"
                  type="email"
                  placeholder="E-mail address *"
                />
                <InputCB name="us_resident">
                  I am a United States resident, I am over the age of 18, and I{" "}
                  qualify to play based on the rules I have read and accepted.
                </InputCB>
                <div className="np__field">
                  <div className="np__captcha">
                    <ReCAPTCHA
                      theme="dark"
                      onChange={(response) => {
                        setFieldValue("recaptcha", response);
                      }}
                      sitekey={props.recaptchaCode}
                    />
                  </div>
                  {errors.recaptcha && (
                    <div className="np__error" data-block={true}>
                      {errors.recaptcha}
                    </div>
                  )}
                </div>
                <button
                  disabled={isSubmitting || isValidating}
                  className="button"
                  data-size="sm"
                  type="submit">
                  {isSubmitting ? "Please wait" : "Submit"}
                </button>
              </form>
            )}
          </Formik>
        </div>
      </div>
    </section>
  );
};

export default DownloadForm;
